import { Spinner, ProgressBar } from "../../shared/ui";

// Props:
//   phase      : { phase_id, question, label, phase_num, phases_total, vote_seconds, players_total } | null
//   voteCount  : number
//   result     : { winner, question, label, votes, counts, scores, phase_num, phases_total } | null
//   final      : { story: [{label, value}], story_text } | null
//   players    : object[]
//   tv         : bool

const COLOR = "#FF6B35";

export default function ScreenplayHost({ phase, voteCount, result, final, players, tv }) {

  // ── Финальная история ────────────────────────────────────────────────────
  if (final) {
    return (
      <div className="w-full animate-slide-up">
        <div style={{ textAlign: "center", marginBottom: tv ? "1.5rem" : "1rem" }}>
          <span style={{
            fontFamily: "'Fredoka One',sans-serif",
            fontSize: tv ? "1.5rem" : "1rem",
            color: COLOR,
            textShadow: "2px 2px 0 #000",
          }}>
            📖 Безумный сценарист — финальная история
          </span>
        </div>

        <div style={{
          background: "#1a0a00",
          border: `3px solid ${COLOR}55`,
          borderRadius: "1.5rem",
          boxShadow: "6px 6px 0 #000",
          padding: tv ? "2rem 2.5rem" : "1.25rem 1.5rem",
          maxWidth: tv ? 900 : "100%",
          margin: "0 auto",
        }}>
          {final.story.map((part, i) => (
            <div key={i} style={{
              display: "flex",
              alignItems: "baseline",
              gap: tv ? "1rem" : "0.6rem",
              marginBottom: tv ? "1rem" : "0.6rem",
              borderBottom: i < final.story.length - 1 ? "1px solid #ffffff0a" : "none",
              paddingBottom: tv ? "0.85rem" : "0.5rem",
            }}>
              <span style={{
                fontFamily: "'Nunito',sans-serif",
                fontSize: tv ? "0.9rem" : "0.7rem",
                color: "#888",
                minWidth: tv ? 90 : 70,
                textTransform: "uppercase",
                letterSpacing: ".06em",
                flexShrink: 0,
              }}>{part.label}</span>
              <span style={{
                fontFamily: "'Fredoka One',sans-serif",
                fontSize: tv ? "1.6rem" : "1.05rem",
                color: "#fff",
                lineHeight: 1.2,
              }}>{part.value}</span>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: tv ? "1.5rem" : "1rem" }}>
          <span style={{
            fontFamily: "'Nunito',sans-serif",
            fontSize: tv ? "0.95rem" : "0.75rem",
            color: "#666",
          }}>🔊 История озвучивается...</span>
        </div>
      </div>
    );
  }

  // ── Результат фазы ───────────────────────────────────────────────────────
  if (result) {
    const entries = Object.entries(result.counts || {})
      .sort((a, b) => b[1] - a[1]);

    return (
      <div className="w-full text-center animate-slide-up">
        <div style={{
          fontFamily: "'Nunito',sans-serif",
          fontSize: tv ? "0.9rem" : "0.7rem",
          color: "#888",
          marginBottom: "0.6rem",
          letterSpacing: ".08em",
          textTransform: "uppercase",
        }}>
          {result.label} · фаза {result.phase_num} из {result.phases_total}
        </div>

        <div style={{
          fontFamily: "'Fredoka One',sans-serif",
          fontSize: tv ? "1.4rem" : "0.95rem",
          color: "#ccc",
          marginBottom: tv ? "1.25rem" : "0.85rem",
        }}>{result.question}</div>

        <div style={{
          background: `${COLOR}18`,
          border: `3px solid ${COLOR}`,
          borderRadius: "1.25rem",
          boxShadow: `5px 5px 0 #000`,
          padding: tv ? "1.25rem 2rem" : "0.85rem 1.25rem",
          display: "inline-block",
          marginBottom: tv ? "1.5rem" : "1rem",
          maxWidth: "90%",
        }}>
          <div style={{
            fontFamily: "'Fredoka One',sans-serif",
            fontSize: tv ? "2rem" : "1.25rem",
            color: "#fff",
            lineHeight: 1.2,
          }}>{result.winner}</div>
          {entries[0] && (
            <div style={{
              fontFamily: "'Nunito',sans-serif",
              fontSize: tv ? "0.9rem" : "0.72rem",
              color: COLOR,
              marginTop: "0.35rem",
            }}>
              {entries[0][1]} {entries[0][1] === 1 ? "голос" : entries[0][1] < 5 ? "голоса" : "голосов"} 🏆
            </div>
          )}
        </div>

        {entries.length > 1 && (
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            justifyContent: "center",
            maxWidth: 700,
            margin: "0 auto",
          }}>
            {entries.slice(1).map(([card, cnt], i) => (
              <div key={i} style={{
                background: "#ffffff08",
                border: "1.5px solid #ffffff15",
                borderRadius: "0.75rem",
                padding: tv ? "0.5rem 1rem" : "0.35rem 0.75rem",
                fontFamily: "'Nunito',sans-serif",
                fontSize: tv ? "0.9rem" : "0.75rem",
                color: "#777",
              }}>
                {card} <span style={{ color: "#555" }}>· {cnt}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Сбор голосов ─────────────────────────────────────────────────────────
  if (phase) {
    return (
      <div className="w-full text-center animate-slide-up">
        <div style={{
          fontFamily: "'Nunito',sans-serif",
          fontSize: tv ? "0.9rem" : "0.7rem",
          color: "#888",
          marginBottom: "0.5rem",
          letterSpacing: ".08em",
          textTransform: "uppercase",
        }}>
          {phase.label} · фаза {phase.phase_num} из {phase.phases_total}
        </div>

        <div style={{
          background: "#1a0a00",
          border: `3px solid ${COLOR}55`,
          borderRadius: "1.5rem",
          boxShadow: "5px 5px 0 #000",
          padding: tv ? "1.5rem 2.5rem" : "0.9rem 1.25rem",
          display: "inline-block",
          maxWidth: "91%",
          marginBottom: tv ? "1.5rem" : "1rem",
        }}>
          <div style={{
            fontFamily: "'Nunito',sans-serif",
            fontSize: tv ? "0.85rem" : "0.7rem",
            color: COLOR,
            marginBottom: "0.4rem",
            opacity: .8,
          }}>📝 Безумный сценарист</div>
          <h2 style={{
            fontFamily: "'Fredoka One',sans-serif",
            fontSize: tv ? "2.4rem" : "1.35rem",
            color: "#fff",
            lineHeight: 1.25,
          }}>{phase.question}</h2>
        </div>

        <div style={{
          fontFamily: "'Fredoka One',sans-serif",
          fontSize: tv ? "1.2rem" : "0.85rem",
          color: "#aaa",
          marginBottom: "0.75rem",
        }}>
          Выбирают: {voteCount} / {phase.players_total}
        </div>

        <ProgressBar value={voteCount} max={Math.max(phase.players_total, 1)} color={COLOR} tv={tv} />

        <div style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: tv ? "0.75rem" : "0.5rem",
          marginTop: tv ? "1.25rem" : "0.85rem",
        }}>
          {players.map((p, i) => (
            <div key={i} className="player-chip" style={{
              backgroundColor: p.color,
              fontSize: tv ? "1.2rem" : "0.85rem",
              padding: tv ? "0.45rem 1.2rem" : "0.3rem 0.85rem",
            }}>{p.name}</div>
          ))}
        </div>
      </div>
    );
  }

  return <Spinner color={COLOR} tv={tv} />;
}